import React from 'react';
import { Box, Button, Grid2 } from '@mui/material';
import './MainSection.css'
const MainSection: React.FC = () => {
  return (
    <Box className='mainSection'>
        <video
            className={'video'}
            src={require('../../assets/video/Comp_9.mp4')}
            autoPlay={true}
            muted={true}
            playsInline={true}
            onEnded={() => console.log("Playback ended")} // Optional callback
        />
      <Box className="ellipse1"></Box>
      <Box className="ellipse2"></Box>
      <Box className="headerText">
        <Box className='textAnim'>
          <Box className='frame1'>
              <Grid2 id='news' container justifyContent="center" alignItems="center" spacing={{xs: 1, md: 2}}
                     columns={{xs: 1}}
                     size={{xs:1}}
              >
                  <Grid2 size={{xs:1}}>
                    <Box className='row'>
                      <Box className='txt1'>
                        <Box className='anim'>
                            <Box className='first txt'>CASINO TABLE GAMES</Box>
                            <Box className='txt text'>WELCOME TO <Box className='yellow'>8RABBITS</Box></Box>
                        </Box>
                      </Box>
                      <Box className='txt2'>
                        <Box className='anim'>
                            <Box className='first txt'>ELITE CASINO GAME DEVELOPMENT</Box>
                            <Box className='txt'>REIMAGINING AND ELEVATING TIMELESS!</Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid2>
              </Grid2>
          </Box>
          <Box className='frame2'></Box>
        </Box>
        <Box className='rowBtn'>
            <Button
                className='readMore'
                onClick={() => {
                    const aboutUdM = document.getElementById('aboutUdM');
                    if (aboutUdM) {
                        aboutUdM.scrollIntoView({behavior: 'smooth'});
                    }
                }}
            >
                Read More
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Arrow 1"
                          d="M0.508419 13.0253C0.230148 13.3321 0.253291 13.8064 0.56011 14.0847C0.86693 14.3629 1.34124 14.3398 1.61951 14.033L0.508419 13.0253ZM12.7493 1.43439C12.7291 1.02067 12.3773 0.701651 11.9636 0.721837L5.22164 1.0508C4.80792 1.07098 4.4889 1.42274 4.50908 1.83646C4.52927 2.25018 4.88102 2.5692 5.29474 2.54902L11.2876 2.25661L11.58 8.24948C11.6002 8.6632 11.952 8.98222 12.3657 8.96203C12.7794 8.94185 13.0984 8.5901 13.0782 8.17637L12.7493 1.43439ZM1.61951 14.033L12.5557 1.9748L11.4446 0.967092L0.508419 13.0253L1.61951 14.033Z"
                          fill="black"/>
                </svg>
            </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MainSection;